/* eslint-disable no-bitwise */
import './ComplianceCategories.scss';

import ccpaIcon from 'images/CCPA.svg';
import classNames from 'classnames';
import { ComplianceCategory } from '@sonar-software/sonar-core';
import coppaIcon from 'images/COPPA.svg';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import gdprIcon from 'images/GDPR.svg';
import hippaIcon from 'images/HIPPA.svg';
import Icon from '@ant-design/icons/lib/components/Icon';
import pciIcon from 'images/PCI.svg';
import piiIcon from 'images/PII.svg';
import { SonarText } from '@ui/text';

import React, { useMemo } from 'react';

function buildCategories(categoryFlags: number | undefined): Array<React.ReactNode> {
	if (
		categoryFlags === undefined ||
		categoryFlags === ComplianceCategory.None ||
		categoryFlags === ComplianceCategory.Any
	) {
		return [];
	}

	const categories: Array<React.ReactNode> = [];

	for (const category in ComplianceCategory) {
		const categoryNumber = Number(category);
		if (isNaN(categoryNumber)) {
			continue;
		}

		if ((categoryFlags & categoryNumber) !== 0) {
			switch (categoryNumber) {
				case ComplianceCategory.CCPA:
					categories.push(
						<Icon
							component={ () => <img
								key={ categoryNumber }
								src={ ccpaIcon } /> }
							key={ categoryNumber } />
					);
					break;
				case ComplianceCategory.COPPA:
					categories.push(
						<Icon
							component={ () => <img
								key={ categoryNumber }
								src={ coppaIcon } /> }
							key={ categoryNumber } />
					);
					break;
				case ComplianceCategory.GDPR:
					categories.push(
						<Icon
							component={ () => <img
								key={ categoryNumber }
								src={ gdprIcon } /> }
							key={ categoryNumber } />
					);
					break;
				case ComplianceCategory.HIPAA:
					categories.push(
						<Icon
							component={ () => <img
								key={ categoryNumber }
								src={ hippaIcon } /> }
							key={ categoryNumber } />
					);
					break;
				case ComplianceCategory.PCI:
					categories.push(
						<Icon
							component={ () => <img
								key={ categoryNumber }
								src={ pciIcon } /> }
							key={ categoryNumber } />
					);
					break;
				case ComplianceCategory.PII:
					categories.push(
						<Icon
							component={ () => <img
								key={ categoryNumber }
								src={ piiIcon } /> }
							key={ categoryNumber } />
					);
					break;
				default:
			}
		}
	}

	return categories;
}

export interface ComplianceCategoriesProps {
	categoryFlags: number | undefined;
	direction?: 'horizontal' | 'vertical';
}

export const ComplianceCategories: React.FC<ComplianceCategoriesProps> = ({
	categoryFlags,
	direction = 'vertical'
}) => {
	const categories = useMemo(() => buildCategories(categoryFlags), [ categoryFlags ]);

	if (categoryFlags === ComplianceCategory.None) {
		return <SonarText>{ COPY_SPECIFIC.NO_COMPLIANCE_CATEGORIES }</SonarText>;
	} else if (categoryFlags === ComplianceCategory.Any) {
		return <SonarText>{ COPY_SPECIFIC.ANY_COMPLIANCE_CATEGORY }</SonarText>;
	}

	return <div className={ classNames('compliance-categories', direction) }>{ categories }</div>;
};
